var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.485 3.10073L6.36 0.843697C6.24978 0.782798 6.12592 0.750854 6 0.750854C5.87408 0.750854 5.75022 0.782798 5.64 0.843697L1.515 3.10167C1.3972 3.16612 1.29886 3.26102 1.23026 3.37646C1.16166 3.4919 1.1253 3.62363 1.125 3.75792V8.24104C1.1253 8.37532 1.16166 8.50706 1.23026 8.6225C1.29886 8.73794 1.3972 8.83284 1.515 8.89729L5.64 11.1553C5.75022 11.2162 5.87408 11.2481 6 11.2481C6.12592 11.2481 6.24978 11.2162 6.36 11.1553L10.485 8.89729C10.6028 8.83284 10.7011 8.73794 10.7697 8.6225C10.8383 8.50706 10.8747 8.37532 10.875 8.24104V3.75838C10.8749 3.62386 10.8387 3.49183 10.7701 3.37613C10.7015 3.26042 10.603 3.1653 10.485 3.10073ZM6 1.49995L9.76594 3.56245L8.37047 4.32651L4.60406 2.26401L6 1.49995ZM6 5.62495L2.23406 3.56245L3.82312 2.69245L7.58906 4.75495L6 5.62495ZM1.875 4.2187L5.625 6.27088V10.2923L1.875 8.24151V4.2187ZM10.125 8.23963L6.375 10.2923V6.27276L7.875 5.45198V7.12495C7.875 7.2244 7.91451 7.31979 7.98483 7.39011C8.05516 7.46044 8.15054 7.49995 8.25 7.49995C8.34946 7.49995 8.44484 7.46044 8.51517 7.39011C8.58549 7.31979 8.625 7.2244 8.625 7.12495V5.04135L10.125 4.2187V8.23917V8.23963Z",
    fill: "#343330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPack);
export default __webpack_public_path__ + "static/media/pack.bcff44e03c2cee28ba0ee2f149d8a80f.svg";
export { ForwardRef as ReactComponent };